import { render, staticRenderFns } from "./Shooting.vue?vue&type=template&id=6653f226&scoped=true&"
import script from "./Shooting.vue?vue&type=script&lang=js&"
export * from "./Shooting.vue?vue&type=script&lang=js&"
import style0 from "./Shooting.vue?vue&type=style&index=0&id=6653f226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653f226",
  null
  
)

export default component.exports